export default __webpack_public_path__ + "static/media/sell1.81cb430a.svg";